export const priceTypeEnum = {
    UNIT: 1,
    DAY: 2,
};
